// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Lfvt8","top":"styles_top__1Cp54","left":"styles_left__ZYbfq","description":"styles_description__3npnH"};